import { LineClamp } from '@/features/shared/components/LineClamp'
import { PromotionalCreditTerms } from '@/features/shop/components/ProductDetailCommon/PromotionalCreditTerms'
import { Prop65Warning } from '@/features/shop/components/ProductDetailCommon/Prop65Warning'
import { Body } from '@shipt/design-system-typography'

type Props = {
  hasFeaturedPromotion?: boolean
}

const GENERAL_DISCLAIMER_TEXT = `
  Content on this site is for reference purposes only. We do not represent or
  warrant that the nutrition, ingredient, allergen and other product
  information on our Web or Mobile sites are accurate or complete, since this
  information comes from the product manufacturers. On occasion, manufacturers
  may improve or change their product formulas and update their labels. We
  recommend that you do not rely solely on the information presented on our
  Web or Mobile sites and that you review the product's label or contact the
  manufacturer directly if you have specific product concerns or questions. If
  you have specific healthcare concerns or questions about the products
  displayed, please contact your licensed healthcare professional for advice
  or answers. Any additional pictures are suggested servings only.
`

export const ProductDisclaimer = ({ hasFeaturedPromotion = false }: Props) => {
  return (
    <section>
      <Body size="sm" variant="secondary" as="div">
        <LineClamp charLimit={332} text={GENERAL_DISCLAIMER_TEXT}>
          <br />
          <Prop65Warning />
          {!!hasFeaturedPromotion && (
            <>
              <br />
              <PromotionalCreditTerms />
            </>
          )}
        </LineClamp>
      </Body>
    </section>
  )
}
